export default function ModalPlugin(_ref) {
  var _ref$setActiveModal = _ref.setActiveModal,
      setActiveModal = _ref$setActiveModal === void 0 ? function (x) {
    return x;
  } : _ref$setActiveModal;
  return [{
    commands: {
      openModal: function openModal(editor, modalOptions) {
        return setActiveModal(modalOptions);
      }
    }
  }];
}